<template>
    <div class="under-construction">
        <SOSlotBase :container-name="'create-status-wa'">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" page-title="Detail Maintenance" @back="back" />
            </template>
            <template v-slot:content>
                <div class="f-16 f-regular f-c-black" style="padding: 30px">
                    <p class="m-d-16">
                        Hi, Owner <br />
                        Tim Smartlink disini
                    </p>
                    <p class="m-d-16">
                        Fitur WhatsApp Auto Sender akan menjalani maintenance untuk memberikan layanan Fitur yang stabil
                        dan lebih baik.
                    </p>
                    <p class="m-d-16">
                        Oleh karena itu Fitur WhatsApp Auto Sender belum bisa di gunakan selama Waktu Maintenance
                        tanggal Selasa, 25 Januari 2022 pukul 00:00-23:59.
                    </p>
                    <p class="m-d-4">Detail :</p>
                    <ul class="m-d-16" style="padding-left: 24px;">
                        <li>
                            Penambahan Maksimal Template Whatsapp Blast Yang tersedia. Dari 10 template menjadi 30 Template
                        </li>
                        <li>
                            Mempercepat Proses Pengiriman Whatsapp Blast.
                        </li>
                        <li>
                            Perubahan UI untuk mempermudah Owner saat mengirim Whatsapp Blast.
                        </li>
                        <li>
                            Jika proses maintenane selesai sebelum tanggal tersebut maka automatis akan terupdate.
                        </li>
                    </ul>
                    <p>
                        *Untuk info lebih lanjut hubungi CS Smartlink
                    </p>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

export default {
    name: "WhatsappAutoSender",
    components: {
        SOSlotBase,
        SOTitleBar,
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
    },
};
</script>
